.bl{max-width:100%;}